import type { C2S, S2C } from "@orbio/shared/protocol";

export interface NetEvents {
  onWelcome?: (playerId: number, world: { w: number; h: number }, portals: { id: number; x: number; y: number }[]) => void;
  onState?: (state: Extract<S2C, { t: "state" }>) => void;
  onDead?: (killedBy: string) => void;
  onFull?: () => void;
  onClose?: (info: { code: number; reason: string; wasClean: boolean }) => void;
  onError?: (err: Event) => void;
}

export class Net {
  private ws: WebSocket | null = null;
  private listeners: NetEvents = {};

  connect(url: string, nick: string, listeners: NetEvents): void {
    this.listeners = listeners;
    const ws = new WebSocket(url);
    this.ws = ws;
    ws.addEventListener("open", () => {
      ws.send(JSON.stringify({ t: "join", name: nick } satisfies C2S));
    });
    ws.addEventListener("message", (ev) => {
      let msg: S2C;
      try { msg = JSON.parse(ev.data); } catch { return; }
      switch (msg.t) {
        case "welcome": this.listeners.onWelcome?.(msg.playerId, msg.world, msg.portals); break;
        case "state":   this.listeners.onState?.(msg); break;
        case "dead":    this.listeners.onDead?.(msg.killedBy); break;
        case "full":    this.listeners.onFull?.(); break;
      }
    });
    ws.addEventListener("close", (e) => this.listeners.onClose?.({ code: e.code, reason: e.reason, wasClean: e.wasClean }));
    ws.addEventListener("error", (e) => this.listeners.onError?.(e));
  }

  sendInput(tx: number, ty: number): void {
    this.ws?.send(JSON.stringify({ t: "input", tx, ty } satisfies C2S));
  }

  sendSplit(): void {
    this.ws?.send(JSON.stringify({ t: "split" } satisfies C2S));
  }

  close(): void {
    this.ws?.close();
    this.ws = null;
  }
}
